import {Link} from "react-router-dom"
import Modal from "../../components/Modal"
import {useModal} from "../../providers/Modal"
import {useState} from "react"
import {useMutation} from "@apollo/client"

import SpinLoader from "../../components/loaders/SpinLoader"
import {DELETE_ORDER, UPDATE_ORDER_STATUS} from "./graphql/mutation"
import DownloadOrderExcel from "./DownloadOrderExcel"

export default function OrderRowItem({order, refetch}) {
  const [status, setStatus] = useState(order.status)
  const {modalId, showModal} = useModal()
  const [UpdateStatus, {loading: updateLoading}] = useMutation(UPDATE_ORDER_STATUS)
  const [DeleteOrder, {loading: deleteLoading}] = useMutation(DELETE_ORDER)
  return (
    <>
      <tr>
        <td className="ps-2">
          {order.status === "pending" && <span className="badge text-bg-warning">Хүлээгдэж байгаа</span>}
          {order.status === "active" && <span className="badge text-bg-primary">Идэвхитэй</span>}
          {order.status === "completed" && <span className="badge text-bg-success">Амжилттай дууссан</span>}
        </td>
        <td className="">
          {/* {order.user.profile.firstname} {order.user.profile.lastname} */}
          <h6 className="font-medium mb-0">
            {order.user.profile.firstname} .{order.user.profile.lastname?.slice(0, 1).toUpperCase()}
          </h6>
          <span className="text-muted">Дэлгүүр: {order.user.profile.numberOfStores || 0}</span>
        </td>
        <td className="">{order.products?.length}</td>
        <td className="">{new Date(parseInt(order.createdAt)).toLocaleString()}</td>
        <td className=" ">
          <div className="d-flex align-items-center justify-content-end">
            <DownloadOrderExcel id={order.id} />
            <Link to={`#_`} onClick={() => showModal(`orderEditModal${order.id}`)} className="ms-2 btn btn-sm btn-light">
              Засах
            </Link>
          </div>
        </td>
      </tr>
      <Modal id={`orderEditModal${order.id}`}>
        <Modal.Body>
          <SpinLoader loading={updateLoading || deleteLoading} absolute />
          <h4>Засах</h4>
          <div className="form-group  mb-4">
            <label htmlFor="">Төлөв</label>
            <select
              className="form-select"
              onChange={(e) => {
                setStatus(e.target.value)
              }}
              defaultValue={status}
            >
              <option value="">Бүх төлөв</option>
              <option value="pending">Хүлээгдэж байгаа</option>
              <option value="active">Идэвхитэй</option>
              <option value="completed">Амжилттай дууссан</option>
            </select>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center justify-content-start">
              <button
                className="btn btn-dark"
                onClick={() => {
                  UpdateStatus({
                    variables: {
                      status: status,
                      id: order.id,
                    },
                    onCompleted: () => {
                      showModal("")
                      refetch()
                    },
                  })
                }}
              >
                Хадгалах
              </button>
              <button className="btn btn-light ms-2" onClick={() => showModal("")}>
                Болих
              </button>
            </div>
            <button
              className="btn btn-danger"
              onClick={() => {
                DeleteOrder({
                  variables: {
                    id: order.id,
                  },
                  onCompleted: () => {
                    showModal("")
                    refetch()
                  },
                })
              }}
            >
              Устгах
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
